import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from 'antd';

const download = (pdf, fileName, linkEncoding = 'data:application/pdf;base64,') => {
  const linkSource = `${linkEncoding}${pdf}`;
  const downloadLink = document.createElement('a');
  downloadLink.href = linkSource;
  downloadLink.download = `${fileName}.pdf`;
  downloadLink.click();
};

const DownloadButton = ({ className, type, fileName, text, onClick, linkEncoding }) => {
  const [loading, setLoading] = useState(false);

  const onClickHandler = async () => {
    if (!loading) {
      try {
        setLoading(true);
        const pdf = await onClick();
        download(pdf, fileName, linkEncoding);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Button type={type} loading={loading} onClick={onClickHandler} className={className}>
      {text}
      <Icon type="cloud-download" />
    </Button>
  );
};

DownloadButton.propTypes = {
  fileName: PropTypes.string.isRequired,
  text: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  linkEncoding: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
};

DownloadButton.defaultProps = {
  text: 'Download PDF',
  linkEncoding: undefined,
  className: undefined,
  type: undefined,
};

export default DownloadButton;
